import { GatsbyBrowser } from "gatsby";
import wrapPage from "./wrap-page";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = wrapPage;
